export default "__VITE_ASSET__E18Wolh$__"